import { AxiosResponse } from 'axios';

import store from '@store/store';
import api from '@core/services/api';
import { IPerformanceProduto } from '@core/models';

import { performance_produto_fetching, performance_produto_success, performance_produto_error } from '@core/slice/performanceProduto.slice';

class VarejoService {
    buscarPerformanceProduto(loja: string, produto: string) {
        store.dispatch(performance_produto_fetching());

        api.get<IPerformanceProduto>(`/api/varejo/produto/performance/${loja}/${produto}`)
            .then((response: AxiosResponse<IPerformanceProduto>) => {
                store.dispatch(performance_produto_success(response.data));
            })
            .catch((e: any) => {
                store.dispatch(performance_produto_error(e.response?.data?.message ||
                    'Erro ao consultar a performance do produto.'
                ));
            })
    }
}
export const varejoService: VarejoService = new VarejoService();